/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { Flex } from '@radix-ui/themes';

import Scores from 'solis/claude/score';
import DeployCard from 'solis/claude/card/deploy';


export default () =>
(
  <Flex direction = 'column' gap = '4' p = '4'>
    <DeployCard />
    <Scores />
  </Flex>
);
